<template>
  <div>
    <v-row class="justify-center">
      <v-col cols="12" md="3" v-for="(item, k) of galleryItems" :key="k">
        <v-card hover @click="showPhotoSwipe(k)">
          <v-img :aspect-ratio="1" :src="item.msrc" alt="picture"></v-img>
        </v-card>
      </v-col>
    </v-row>
    <v-fade-transition>
      <v-photoswipe
        v-show="isOpen"
        :isOpen="isOpen"
        :items="galleryItems"
        :options="options"
        @close="hidePhotoSwipe"
      ></v-photoswipe>
    </v-fade-transition>
  </div>
</template>

<script>
import { PhotoSwipe } from "v-photoswipe";

export default {
  name: "PhotoSwipeGallery",
  components: {
    "v-photoswipe": PhotoSwipe
  },
  props: {
    options: {
      type: Object,
      default: () => ({
        index: 0,
        shareEl: false,
        fullscreenEl: true,
        zoomEl: true,
        bgOpacity: 0.7,
        showAnimationDuration: 0,
        hideAnimationDuration: 0
      })
    },
    galleryItems: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    isOpen: false,
    isOpenGallery: false
  }),
  methods: {
    showPhotoSwipe(index) {
      this.isOpen = true;
      this.$set(this.options, "index", index);
    },
    hidePhotoSwipe() {
      this.isOpen = false;
    }
  }
};
</script>
